export const VEHICLE_STATUS_LIST = 'VEHICLE_STATUS_LIST';
export const VEHICLE_STATUS_LIST_SUCCESS = 'VEHICLE_STATUS_LIST_SUCCESS';
export const VEHICLE_STATUS_LIST_ERROR = 'VEHICLE_STATUS_LIST_ERROR';

export const VEHICLE_STATUS_DETAILS = 'VEHICLE_STATUS_DETAILS';
export const VEHICLE_STATUS_DETAILS_SUCCESS = 'VEHICLE_STATUS_DETAILS_SUCCESS';
export const VEHICLE_STATUS_DETAILS_ERROR = 'VEHICLE_STATUS_DETAILS_ERROR';

export const ADD_VEHICLE_STATUS_DETAILS = 'ADD_VEHICLE_STATUS_DETAILS';
export const ADD_VEHICLE_STATUS_DETAILS_SUCCESS = 'ADD_VEHICLE_STATUS_DETAILS_SUCCESS';
export const ADD_VEHICLE_STATUS_DETAILS_ERROR = 'ADD_VEHICLE_STATUS_DETAILS_ERROR';

export const UPDATE_VEHICLE_STATUS = 'UPDATE_VEHICLE_STATUS';
export const UPDATE_VEHICLE_STATUS_SUCCESS = 'UPDATE_VEHICLE_STATUS_SUCCESS';
export const UPDATE_VEHICLE_STATUS_ERROR = 'UPDATE_VEHICLE_STATUS_ERROR';

export const DELETE_VEHICLE_STATUS = 'DELETE_VEHICLE_STATUS';
export const DELETE_VEHICLE_STATUS_SUCCESS = 'DELETE_VEHICLE_STATUS_SUCCESS';
export const DELETE_VEHICLE_STATUS_ERROR = 'DELETE_VEHICLE_STATUS_STATUS';

export const ASSIGN_USERS_LIST = 'ASSIGN_USERS_LIST';
export const ASSIGN_USERS_LIST_SUCCESS = 'ASSIGN_USERS_LIST_SUCCESS';
export const ASSIGN_USERS_LIST_ERROR = 'ASSIGN_USERS_LIST_ERROR';
